import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [brand, setBrand] = useState({ trading_name: "MAG Installations", logo: "" });

  const refresh = useCallback(() => {
    api.get("/settings/public").then((r) => setBrand(r.data)).catch(() => {});
  }, []);

  useEffect(() => refresh(), [refresh]);

  return <SettingsContext.Provider value={{ brand, refresh }}>{children}</SettingsContext.Provider>;
}

export const useBrand = () => useContext(SettingsContext);
